var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_10239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 34.2588H39.1841V36.9255H42.5334V34.2588Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 40.3604H39.1841V43.027H42.5334V40.3604Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 46.4619H39.1841V49.1286H42.5334V46.4619Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 58.667H39.1841V61.3337H42.5334V58.667Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 52.5654H39.1841V55.2321H42.5334V52.5654Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 64.7705H39.1841V67.4372H42.5334V64.7705Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5334 70.875H39.1841V73.5417H42.5334V70.875Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 28.0957H45.3867V30.7624H48.7361V28.0957Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 34.1992H45.3867V36.8659H48.7361V34.1992Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 40.3037H45.3867V42.9704H48.7361V40.3037Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 52.5068H45.3867V55.1735H48.7361V52.5068Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 46.4053H45.3867V49.0719H48.7361V46.4053Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 58.6104H45.3867V61.277H48.7361V58.6104Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 64.7148H45.3867V67.3815H48.7361V64.7148Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7361 70.874H45.3867V73.5407H48.7361V70.874Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 28.0957H51.5867V30.7624H54.936V28.0957Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 34.1992H51.5867V36.8659H54.936V34.1992Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 40.3037H51.5867V42.9704H54.936V40.3037Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 52.5068H51.5867V55.1735H54.936V52.5068Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 46.4053H51.5867V49.0719H54.936V46.4053Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 58.6104H51.5867V61.277H54.936V58.6104Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 64.7148H51.5867V67.3815H54.936V64.7148Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.936 70.874H51.5867V73.5407H54.936V70.874Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.208 40.3037H61.8586V42.9704H65.208V40.3037Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.208 46.4053H61.8586V49.0719H65.208V46.4053Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.208 52.5068H61.8586V55.1735H65.208V52.5068Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.208 58.6104H61.8586V61.277H65.208V58.6104Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6535 40.3037H67.3042V42.9704H70.6535V40.3037Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6535 46.4053H67.3042V49.0719H70.6535V46.4053Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6535 52.5068H67.3042V55.1735H70.6535V52.5068Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6613 62.333C67.8533 62.333 62.3333 67.853 62.3333 74.6663C62.3333 81.4797 67.8533 86.9997 74.6666 86.9997C81.4799 86.9997 86.9999 81.4797 86.9999 74.6663C86.9999 67.853 81.4799 62.333 74.6613 62.333ZM82.2186 76.6663H76.6613V82.2237C76.6613 83.3277 75.7653 84.2237 74.6613 84.2237C73.5519 84.2237 72.6613 83.3277 72.6613 82.2237V76.6663H67.1093C66.0053 76.6663 65.1093 75.7703 65.1093 74.6663C65.1093 73.5623 66.0053 72.6663 67.1093 72.6663H72.6613V67.1143C72.6613 66.0103 73.5573 65.1143 74.6613 65.1143C75.7653 65.1143 76.6613 66.0103 76.6613 67.1143V72.6663H82.2186C83.3279 72.6663 84.2239 73.5623 84.2239 74.6663C84.2239 75.7703 83.3279 76.6663 82.2186 76.6663Z",
    fill: "#26BAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 36.1333V23.5493C59.0986 23.5493 56.0426 23 52.0613 23C44.616 23 33.9306 24.9227 33.9306 35.952C33.9306 44.7493 33.9306 70.3413 33.9306 78.6667H22.9973V87H65.232C64.2186 86.224 63.3013 85.3307 62.5066 84.3333H25.6666V81.3333H33.9333H56.4453H59.0986H60.6426C60.2373 80.4853 59.9093 79.5947 59.664 78.6667C59.3226 77.3893 59.1253 76.0533 59.1253 74.6667C59.1253 74.6347 59.128 74.608 59.128 74.5787H59.112V38.8H73.4V59.1893C73.816 59.1573 74.2346 59.128 74.6586 59.128C75.1333 59.128 75.6026 59.1573 76.0666 59.1973V36.1333H59.0986ZM36.6 78.6667V35.952C36.6 29.1253 41.8026 25.6667 52.064 25.6667C53.7573 25.6667 55.2826 25.7733 56.4346 25.888V78.6667H36.6Z",
    fill: "#0270B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_10239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOffice);
export default __webpack_public_path__ + "static/media/new-office.164a2bb7d55147a148ab9408d20205f2.svg";
export { ForwardRef as ReactComponent };